if (!customElements.get("sc-collection-list-tabs")) {
  class ScCollectionListTabs extends HTMLElement {
    connectedCallback() {
      const tabs = this.querySelectorAll("[data-sc-collection-list-tab]");
      const panels = this.querySelectorAll("[data-sc-collection-list-panel]");
      if (!tabs.length || tabs.length !== panels.length) return;

      this._tabs = tabs;
      this._panels = panels;
      this._abort = new AbortController();
      const { signal } = this._abort;

      this._onSectionLoad = (event) => {
        if (event.target && event.target.contains(this)) {
          this.activate(0);
        }
      };

      document.addEventListener("shopify:section:load", this._onSectionLoad, {
        signal,
      });

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => this.activate(index), { signal });
        tab.addEventListener("keydown", (e) => this.onTabKeydown(e, index), {
          signal,
        });
      });
    }

    disconnectedCallback() {
      this._abort?.abort();
    }

    activate(index) {
      if (!this._tabs || !this._panels) return;

      this._tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute("aria-selected", selected ? "true" : "false");
        tab.tabIndex = selected ? 0 : -1;
      });

      this._panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
    }

    onTabKeydown(e, index) {
      const len = this._tabs.length;
      let next = index;

      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        e.preventDefault();
        next = (index + 1) % len;
      } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        e.preventDefault();
        next = (index - 1 + len) % len;
      } else if (e.key === "Home") {
        e.preventDefault();
        next = 0;
      } else if (e.key === "End") {
        e.preventDefault();
        next = len - 1;
      } else {
        return;
      }

      this.activate(next);
      this._tabs[next].focus();
    }
  }

  customElements.define("sc-collection-list-tabs", ScCollectionListTabs);
}

if (!customElements.get("sc-collection-list-load")) {
  class ScCollectionListLoad extends HTMLElement {
    connectedCallback() {
      this._grid = this.querySelector(".sc-collection-list__grid");
      this._button = this.querySelector("[data-sc-load-more]");
      if (!this._grid || !this._button) return;

      this._batch = Math.max(1, parseInt(this.dataset.scLoadBatch, 10) || 1);
      this._abort = new AbortController();
      const { signal } = this._abort;

      this._button.addEventListener("click", () => this.loadNext(), { signal });
    }

    disconnectedCallback() {
      this._abort?.abort();
    }

    loadNext() {
      if (!this._grid || !this._button) return;
      const hidden = this._grid.querySelectorAll("li[hidden]");
      for (let i = 0; i < this._batch && i < hidden.length; i++) {
        hidden[i].removeAttribute("hidden");
      }
      if (this._grid.querySelector("li[hidden]") == null) {
        this._button.hidden = true;
        const wrap = this._button.closest(".sc-collection-list__load-wrap");
        if (wrap) wrap.hidden = true;
      }
    }
  }

  customElements.define("sc-collection-list-load", ScCollectionListLoad);
}
